import { take, put, call } from "redux-saga/effects";

import { AuthActions, LOGOUT } from "../../actions";

import { authHttpService } from "../../apiService";
import { history } from "../../../history";

export function* logoutFlow() {
  while (true) {
    yield take(LOGOUT);
    yield call([authHttpService, authHttpService.Logout]);
    history.push("/");
    yield put(AuthActions.logoutSuccess());
  }
}
